(function () {
  'use strict';
  function initGuide(root) {
    if (!root || root.dataset.nwbsReady === 'true') return;
    root.dataset.nwbsReady = 'true';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function getTarget(hash) {
      if (!hash || hash.indexOf('#nwbs-') !== 0) return null;
      var target = document.getElementById(hash.slice(1));
      return target && root.contains(target) ? target : null;
    }
    function showTarget(target, scroll) {
      if (target.classList.contains('nwbs-month')) {
        var details = target.querySelector('details');
        if (details) details.open = true;
      }
      if (scroll) {
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        window.requestAnimationFrame(function () {
          target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
        });
      }
    }
    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#nwbs-"]');
      if (!link || !root.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
      var target = getTarget(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      showTarget(target, true);
    });
    root.querySelectorAll('[data-nwbs-enhanced]').forEach(function (element) { element.hidden = false; });
    var monthJump = root.querySelector('#nwbs-month-jump');
    if (monthJump) monthJump.addEventListener('change', function () {
      var target = getTarget('#nwbs-' + monthJump.value);
      if (target) showTarget(target, true);
    });
    var monthSearch = root.querySelector('#nwbs-month-search');
    var monthTiles = Array.from(root.querySelectorAll('[data-nwbs-search]'));
    var clearSearch = root.querySelector('[data-nwbs-clear]');
    var searchStatus = root.querySelector('#nwbs-search-status');
    function filterMonths() {
      var query = monthSearch.value.trim().toLocaleLowerCase();
      var tokens = query.split(/\s+/).filter(Boolean);
      var count = 0;
      monthTiles.forEach(function (tile) {
        var match = tokens.every(function (token) { return tile.dataset.nwbsSearch.indexOf(token) !== -1; });
        tile.hidden = !match;
        if (match) count += 1;
      });
      clearSearch.hidden = !query;
      searchStatus.textContent = !query ? 'Showing all 12 months.' : count ? count + (count === 1 ? ' month matches. Choose it below.' : ' months match. Choose one below.') : 'No month found. Try a month, gemstone, or color, or clear your search.';
    }
    if (monthSearch && clearSearch && searchStatus) {
      monthSearch.addEventListener('input', filterMonths);
      clearSearch.addEventListener('click', function () { monthSearch.value = ''; filterMonths(); monthSearch.focus(); });
    }
    root.querySelectorAll('[data-nwbs-shopping]').forEach(function (section) {
      var rail = section.querySelector('.nwbs-product-rail');
      var filter = section.querySelector('[data-nwbs-product-month]');
      var previous = section.querySelector('[data-nwbs-prev]');
      var next = section.querySelector('[data-nwbs-next]');
      var status = section.querySelector('[data-nwbs-product-status]');
      var cards = Array.from(rail.querySelectorAll('.nwbs-product-card'));
      function updateButtons() {
        previous.disabled = rail.scrollLeft < 3;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
      }
      function filterProducts() {
        var month = filter.value;
        var count = 0;
        cards.forEach(function (card) {
          var match = !month || card.dataset.nwbsMonths.split(' ').indexOf(month) !== -1;
          card.hidden = !match;
          if (match) count += 1;
        });
        rail.scrollTo({ left: 0, behavior: 'instant' });
        var label = month ? ' for ' + filter.options[filter.selectedIndex].text : '';
        status.textContent = count ? count + (count === 1 ? ' piece' : ' pieces') + label + '. Open a piece for current sizes and details.' : 'No featured pieces are available' + label + ' right now. Choose another month or explore the guide below.';
        updateButtons();
      }
      function move(direction) {
        var first = cards.find(function (card) { return !card.hidden; });
        var distance = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : rail.clientWidth;
        rail.scrollBy({ left: direction * distance, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      filter.addEventListener('change', filterProducts);
      rail.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons, { passive: true });
      filterProducts();
    });

    var initial = getTarget(window.location.hash);
    if (initial) showTarget(initial, false);
    root.querySelectorAll('.nwbs-media img').forEach(function (img) {
      function showFallback() {
        var media = img.closest('.nwbs-media');
        if (!media || media.classList.contains('nwbs-image-error')) return;
        media.classList.add('nwbs-image-error');
        var label = document.createElement('span');
        label.textContent = 'Explore the gemstone story below.';
        media.appendChild(label);
      }
      img.addEventListener('error', showFallback, { once: true });
      if (img.complete && img.naturalWidth === 0) showFallback();
    });
  }
  initGuide(document.getElementById('nw-birthstone-guide'));
  document.addEventListener('shopify:section:load', function (event) {
    initGuide(event.target.querySelector('#nw-birthstone-guide'));
  });
})();
